<div class="content-container px-4">
  <h2 class="text-xl font-bold text-gray-800 dark:text-white my-4">
    Test de prisma
  </h2>
  <nz-card nzTitle="Prisma Pool Monitor" class="monitor-card">
    <button nz-button nzType="primary" (click)="startMonitoring()" [disabled]="running">
      Iniciar
    </button>
    <button nz-button nzType="default" (click)="stopMonitoring()" [disabled]="!running">
      Parar
    </button>
    <button nz-button nzType="dashed" (click)="downloadLog()" [disabled]="!history.length">
      Guardar log
    </button>
  </nz-card>

  <nz-row [nzGutter]="16" class="metrics-row">
    <nz-col nzSpan="4"><nz-statistic nzTitle="Busy" [nzValue]="busy"></nz-statistic></nz-col>
    <nz-col nzSpan="4"><nz-statistic nzTitle="Idle" [nzValue]="idle"></nz-statistic></nz-col>
    <nz-col nzSpan="4"><nz-statistic nzTitle="Open" [nzValue]="open"></nz-statistic></nz-col>
    <nz-col nzSpan="4"><nz-statistic nzTitle="QPS" [nzValue]="qps"></nz-statistic></nz-col>
    <nz-col nzSpan="4"><nz-statistic nzTitle="Wait" [nzValue]="queriesWait"></nz-statistic></nz-col>
  </nz-row>

  <nz-table #historyTable [nzData]="history" [nzScroll]="{ y: '240px' }" nzSize="small" class="history-table">
    <thead>
      <tr>
        <th>Hora</th>
        <th>Busy</th>
        <th>Idle</th>
        <th>Open</th>
        <th>QPS</th>
        <th>Wait</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of history">
        <td>{{ row.time }}</td>
        <td>{{ row.busy }}</td>
        <td>{{ row.idle }}</td>
        <td>{{ row.open }}</td>
        <td>{{ row.qps }}</td>
        <td>{{ row.queriesWait }}</td>
      </tr>
    </tbody>
  </nz-table>

  <div id="chart-container" style="height:300px;"></div>